export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="text-sm text-gray-500 space-y-2">
            <div>
              &copy; {new Date().getFullYear()} APEL Stanislas. Tous droits
              réservés (Réalisé par JUNIOR ISEP).
              {/* Ayoub AYOUBI (https://ayoubayoubi.fr/) */}
            </div>
            <a href="/legal-notice" className="hover:underline">
              Mentions Légales
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
